const footerEvents = {
  FETCH_PRICE_LIST: 'category/fetch_price_list',
  FETCH_FOOTER_CATEGORIES: 'category/fetch_footer_categories',
  FETCH_ABOUT_US: 'category/about_us',
  FETCH_DYNAMIC_FOOTER_LINKS: 'product/popular_links',
};

export default footerEvents;
